<template>
  <div class="business-list-wrapper"  @scroll="scrollCheck">
    <div class="loading-wrapper" v-if="loading">
      <LoadingWidget type="bar" ref="loading"></LoadingWidget>
    </div>

    <div v-else class="list-wrapper">
      <ListRow
        v-for="business in businessRows" 
        :key="business.id"
        :model="business">
      </ListRow>
    </div>
  </div>
</template>

<script>
import ListRow from '@/components/lists/ListRow'
import LoadingWidget from '@Common/elements/LoadingWidget'
import { useBusinessStore } from '@/stores/BusinessStore'

export default {
  name: 'BusinessList',
  
  setup() {
    const businessSet = useBusinessStore()

    return {
      businessSet
    }
  },

  data() {
    return {
      lineCenterKey: 'name',
      loading: true,
      newBusinessName: '',
      newBusinessDefCat: '',
      focus: true,
    }
  },

  computed: {
    businessRows() {
      return this.businessSet.getSet.map(b => ({
        ...b,
        link: {
          name: 'business',
          params: { id: b.id },
        },
        cells: [
          {
            id: 'name',
            value: b.name,
            isLink: true,
          }
        ],
      }))
    },
  },

  methods: {
    scrollCheck(e) {
      if (!this.businessSet.getNextLink) return
      const t = e.target
      if (t.scrollTop >= (t.scrollHeight - t.offsetHeight) && !!this.businessSet.getNextLink) {
        this.showLoading()
        this.businessSet.fetch(this.businessSet.getNextLink, true)
          .then(() => {
            this.hideLoading()
          })
      }
    },
  },

  created() {
    this.businessSet.fetch().then(() => {
      this.loading = false
    })
  },

  components: {
    ListRow,
    LoadingWidget,
  }
}
</script>

<style lang="scss" scoped>
.business-list-wrapper {
  height: 100%;
  overflow: auto;
}
</style>
